export default "__VITE_ASSET__28dba50e__"